import { View, StyleSheet } from "react-native";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ArrowLeft } from "@phosphor-icons/react";
import AdminLayout from "../../layouts/AdminLayout.web";
import FacultyProfileTabContainer from "../../containers/settings/FacultyProfileTabContainer/FacultyProfileTabContainer";
import CustomButton from "../../components/common/general/CustomButton/CustomButton";
import CustomText from "../../components/common/general/CustomText/CustomText";
import { RootStackParamList } from "../../navigation/AppNavigator.web";

function AdminProfileView() {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();

  const handleGoBack = () => {
    navigation.goBack();
  };

  return (
    <AdminLayout withPadding={false}>
      <View style={styles.container}>
        <View style={styles.header}>
          <CustomButton
            onPress={handleGoBack}
            text=""
            leftIcon={<ArrowLeft size={20} color="#475467" />}
            styleType="transparent"
            size="m"
            style={styles.backButton}
            aria-label="Go back"
          />
          <CustomText text="Profile" size="l" weight="ultraBold" useTranslationText={false} style={styles.title} />
        </View>
        <View style={styles.content}>
          <FacultyProfileTabContainer />
        </View>
      </View>
    </AdminLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    backgroundColor: "#fff",
  },
  backButton: {
    marginRight: 16,
    padding: 8,
  },
  title: {
    fontSize: 24,
    color: "#111827",
  },
  content: {
    flex: 1,
  },
});

export default AdminProfileView;
